import { render, staticRenderFns } from "./Brochure.vue?vue&type=template&id=4c20fb3a&scoped=true&"
import script from "./Brochure.vue?vue&type=script&lang=js&"
export * from "./Brochure.vue?vue&type=script&lang=js&"
import style0 from "./Brochure.vue?vue&type=style&index=0&id=4c20fb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20fb3a",
  null
  
)

export default component.exports